import Modal from "@/components/common/modal";
import { Button, Icon } from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  title: string;
  description: string;
  cancelText?: string;
  acceptText: string;
  acceptVariant?:
    | "default"
    | "secondary"
    | "danger-secondary"
    | "tertiary"
    | "ghost"
    | "quiet"
    | "ghost-blue"
    | "danger-primary"
    | "danger-tertiary"
    | "alpha-neutral";
  isLoading?: boolean;
  modalContentClassName?: string;
  children: React.ReactNode;
  disabledAccept?: boolean;
}

const InputModalBase = ({
  isOpen,
  onClose,
  onAccept,
  title,
  description,
  cancelText = "Cancelar",
  acceptText,
  acceptVariant = "default",
  isLoading = false,
  modalContentClassName = "max-w-[520px] w-full gap-7",
  children,
  disabledAccept = false,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      description={description}
      modalContentClassName={modalContentClassName}
    >
      <div className="flex flex-col gap-4">
        {children}
        <div className="w-full grid grid-cols-1 tablet:grid-cols-2 gap-3 pt-1">
          <Button
            size="lg"
            type="button"
            className="w-full rounded-lg cursor-pointer"
            variant="tertiary"
            onClick={onClose}
          >
            {cancelText}
          </Button>
          <Button
            size="lg"
            variant={acceptVariant}
            className="w-full rounded-lg cursor-pointer"
            type="submit"
            disabled={isLoading || disabledAccept}
            onClick={onAccept}
          >
            {acceptText}
            {isLoading && (
              <Icon
                type="far"
                name="spinner-third"
                className={cn("text-current", "animate-spin")}
              />
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default InputModalBase;
